import { getPersistentJson } from '../vrs-auth/storage';
/**
 * The queue call that belongs to this room: this page's match, else the call
 * the dashboard stored before navigating here (the web interpreter reaches the
 * room with a full page load). A call for another room never counts, so a
 * stale match cannot aim a tool at the wrong call.
 *
 * @param {string} [room] - The conference room.
 * @param {Object} [matchData] - The queue's current match.
 * @returns {IToolsActiveCall | undefined}
 */
export function activeToolsCall(room, matchData) {
    if (!room) {
        return undefined;
    }
    const own = (value) => {
        const call = value && typeof value === 'object' ? value : undefined;
        return typeof call?.callId === 'string' && call.callId && call.roomName === room
            ? call : undefined;
    };
    return own(matchData) || own(getPersistentJson('vrs_active_call'));
}
